import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { motion } from "framer-motion";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className={`relative inline-flex h-9 w-16 items-center rounded-full border border-border bg-secondary px-1 transition-colors ${className}`}
    >
      <motion.span
        layout
        transition={{ type: "spring", stiffness: 500, damping: 32 }}
        className={`flex h-7 w-7 items-center justify-center rounded-full bg-card shadow-sm ${isDark ? "ml-auto" : ""}`}
      >
        {isDark ? <Moon className="h-4 w-4 text-violet" /> : <Sun className="h-4 w-4 text-coral" />}
      </motion.span>
    </button>
  );
}
